import http from '@/utils/http'

/**
 * 获取产品领域列表
 */
export function getProductDomain() {
  return http({
    url: '/api/shop/product_domain',
    method: 'get'
  })
}

/**
 * 提交供应商入驻申请
 * @param {Object} data 申请数据
 */
export function submitShopApply(data) {
  return http({
    url: '/api/shop/shop_apply',
    method: 'post',
    data,
    needLogin: true
  })
}

/**
 * 获取供应商入驻申请状态
 */
export function getShopApplyStatus() {
  return http({
    url: '/api/shop/shop_apply_status',
    method: 'get',
    needLogin: true
  })
}

/**
 * 获取供应商申请信息（用于重新申请时回填数据）
 */
export function getShopApplyInfo() {
  return http({
    url: '/api/shop/my_apply',
    method: 'get',
    needLogin: true
  })
}

/**
 * 上传图片
 * @param {FormData} formData 图片文件数据
 */
export function uploadImage(formData) {
  return http({
    url: '/api/upload/image',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}